var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, Fragment } from "react/jsx-runtime";
import Logger from "@ane/core/lib/services/logging/Logger";
import { Loading } from "@ane/ui-components/lib/components/Loading";
import { someRequestHasFailed, AsyncRequestStatus, allRequestsHaveCompleted } from "@ane/core/lib/models";
import ___default from "lodash";
import { ControlTowerError } from "./ControlTowerError.js";
import { useState, useRef, useEffect } from "react";
import { WorkspaceMigrationStatusCodes } from "@ane/core/lib/models/IAsyncWrapper/WorkspaceMigrationModels";
import { isMigrationErrorStatusCode } from "@ane/core/lib/utils/WorkspaceMigration.utils";
import { EntityManagementGroupTelemetryEventNames } from "@ane/exp-data/lib/telemetry/EntityManagementGroupTelemetryEventNames";
const defaultSpinnerProps = { ariaLabel: "Loading", label: "Loading" };
const ControlTowerLoading = ({
  resources,
  loadingPrefix = "Loading",
  children,
  useProgressIndicator = true,
  spinnerProps = defaultSpinnerProps,
  showLoadingText = true,
  useAllRequestsHaveResolved = false,
  entityManagementGroupProps,
  showIndicatorOnlyForInitialRender = false,
  progressIndicatorProps,
  hideDriButton = false
}) => {
  resources = resources.filter((r) => !!r.asyncData && !!r.displayName);
  const [retryTried, setRetryTried] = useState(
    resources.reduce(
      (prevValue, currentValue) => __spreadProps(__spreadValues({}, prevValue), { [currentValue.displayName]: false }),
      {}
    )
  );
  var initialLoadComplete = useRef(false);
  useEffect(() => {
    return () => {
      if (!!entityManagementGroupProps) {
        Logger.setEntityManagementGroup("");
        Logger.trackEvent({
          measurements: {},
          name: EntityManagementGroupTelemetryEventNames.Entity_Management_Group_Empty,
          properties: {}
        });
      }
    };
  }, []);
  if (someRequestHasFailed(resources.map((r) => r.asyncData.status))) {
    return /* @__PURE__ */ jsx(Fragment, { children: resources.filter((r) => r.asyncData.status == AsyncRequestStatus.Failed).map((r, i) => {
      var _a, _b;
      const { errorContext, error } = r == null ? void 0 : r.asyncData;
      let { displayError, correlationId, statusCode } = errorContext || {};
      return /* @__PURE__ */ jsx(
        ControlTowerError,
        {
          displayErrorMessage: (_a = displayError != null ? displayError : error) != null ? _a : "An unknown error occured",
          displayErrorPrefix: (_b = r.displayErrorPrefix) != null ? _b : "Error: ",
          correlationId,
          errorContext,
          onRetry: !!r.onRetry && statusCode !== WorkspaceMigrationStatusCodes.MovedPermanently ? () => {
            r.onRetry && r.onRetry();
            setRetryTried(__spreadProps(__spreadValues({}, retryTried), { [r.displayName]: true }));
          } : void 0,
          hideDriButton: !!r.onRetry && !retryTried[r.displayName] || isMigrationErrorStatusCode(r.asyncData) || hideDriButton
        },
        i
      );
    }) });
  }
  if (allRequestsHaveCompleted(resources.map((r) => r.asyncData.status))) {
    if (!!entityManagementGroupProps) {
      Logger.setEntityManagementGroup(
        entityManagementGroupProps.mapEntityExperimentationGroup(entityManagementGroupProps.entityRequest)
      );
      Logger.trackEvent({
        measurements: {},
        name: EntityManagementGroupTelemetryEventNames.Entity_Management_Group_From_Selector,
        properties: {}
      });
    }
    if (showIndicatorOnlyForInitialRender) {
      initialLoadComplete.current = true;
    }
  }
  if (initialLoadComplete.current && showIndicatorOnlyForInitialRender) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  } else {
    const defaultProgressIndicatorProps = {
      ariaLabel: `${loadingPrefix}: ${getPendingResourcesName(resources)}`,
      percentComplete: getPercentageComplete(resources),
      label: showLoadingText ? `${loadingPrefix} ${getPendingResourcesName(resources)}` : `${loadingPrefix}`
    };
    return /* @__PURE__ */ jsx(
      Loading,
      {
        useAllRequestsHaveResolved,
        status: resources.map((r) => r.asyncData.status),
        data: {},
        useProgressIndicator,
        progressIndicatorProps: progressIndicatorProps != null ? progressIndicatorProps : defaultProgressIndicatorProps,
        spinnerProps,
        children
      }
    );
  }
};
const getPercentageComplete = (resources) => {
  if (resources.length == 1) {
    return void 0;
  }
  const completed = ___default.sum(
    resources.filter((r) => r.asyncData.status == AsyncRequestStatus.Completed).map((r) => {
      var _a;
      return (_a = r.relativeSize) != null ? _a : 1;
    })
  );
  const total = ___default.sum(resources.map((r) => {
    var _a;
    return (_a = r.relativeSize) != null ? _a : 1;
  }));
  return total > 0 ? completed / total : 1;
};
const getPendingResourcesName = (resources) => {
  return resources.filter((r) => r.asyncData.status == AsyncRequestStatus.Pending).map((r) => r.displayName).join(", ");
};
export {
  ControlTowerLoading
};
//# sourceMappingURL=ControlTowerLoading.js.map
